import React from 'react';
import { connect } from 'react-redux';
import { IconButton, ListItemButton, Box, ListItemText } from '@mui/material';
import { createActions } from '../../../store';
import { RotateRightRounded } from '@mui/icons-material';

const BackdropRotateListItem = (props) => {
    const { rotation, updateBackgroundSettings } = props;

    const onRotateClick = () => {
        var newRotation = rotation + 1;
        if (newRotation > 3) newRotation = 0;

        updateBackgroundSettings({ rotation: newRotation });
    };

    return (
        <ListItemButton onClick={onRotateClick}>
            <ListItemText>
                Rotate
            </ListItemText>
            <Box>
                <IconButton
                    onClick={onRotateClick}
                    size='small'
                >
                    <RotateRightRounded />
                </IconButton>
            </Box>
        </ListItemButton>
    );
};

const mapStateToProps = (state) => {
    const { rotation } = state.createPreview.present.videoSettings.background;
    return { rotation }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropRotateListItem);